import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AccountContext, isDemo } from '../GlobalContex';
export const PrivateElement = ({ element }) => {
  const { isAuthorized } = useContext(AccountContext);
  if (isDemo) return element;
  return isAuthorized ? element : <Navigate to={'/register'} replace />;
};
